export default {"src":"/_next/static/image/public/images/menu_rx_white.df9d7461d183410caf219a376677d605.svg","height":15,"width":13};